export default __webpack_public_path__ + "static/media/Xiva.03079730.jpg";